<app-counterparty-finder (ctpSelectionChangeEvent)="onCtpSelectionChanged($event)"></app-counterparty-finder>
